import React from 'react'
import { styles } from './styles'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const useStyles = makeStyles(styles)

const rotateIfNecessary = (condition, content) =>
    condition ? <div style={{ transform: 'rotate(-90deg)' }}>{content}</div> : content

const getInlineStyles = lua => ({
    animationDirection: lua.direction ? 'alternate' : 'alternate-reverse',
})

export const LiveUserActionImg = React.memo(({ lua, horizontal }) => {
    if (!lua.emoji) {
        return <></>
    }

    const classes = useStyles()

    return rotateIfNecessary(
        horizontal,
        <span className={classes.lua} style={getInlineStyles(lua)}>
            <svg width="25" height="25">
                <use href={`#${lua.emoji}`} />
            </svg>
        </span>,
    )
})

export const LiveUserActionUnicode = React.memo(({ lua, horizontal }) => {
    const classes = useStyles()
    return (
        <span className={classes.lua} role="img" style={getInlineStyles(lua)}>
            {rotateIfNecessary(horizontal, lua.emoji)}
        </span>
    )
})

export const LiveUserAction = React.memo(({ lua, horizontal, travelDistance }) => {
    const classes = useStyles()

    return (
        <span
            className={clsx(classes.luaContainer, 'lua-idle', horizontal && classes.horizontal)}
            ref={ref => {
                if (ref) ref.classList.remove('lua-idle')
            }}
            style={{
                '--offset': `${lua.offset}px`,
                '--travelDistance': travelDistance,
                animationDelay: `${lua.delay}ms`,
            }}
        >
            {lua.isUnicode ? (
                <LiveUserActionUnicode horizontal={horizontal} lua={lua} />
            ) : (
                <LiveUserActionImg horizontal={horizontal} lua={lua} />
            )}
        </span>
    )
})
